import LanguageCmsEditor from '@/pages/admin/content/components/LanguageCmsEditor';

export default function AdminPashtoCmsPage() {
  return <LanguageCmsEditor language="ps" />;
}